import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Container = styled.button`
  width: 100%;
  height: 56px;
  background-color: ${theme.colors.blue100};
  border-radius: ${theme.border.mediumRadius};
  border: none;

  font-family: ${theme.font.poppins};
  color: ${theme.colors.blue900};
  font-weight: ${theme.font.semiBold};
  font-size: ${theme.font.sizes.normal};
  font-style: normal;

  cursor: pointer;

  transition: filter 300ms;

  &:hover {
    filter: brightness(0.6);
  }

  svg {
    margin-right: 10px;
  }
`;
